import React,{useState,useEffect} from 'react';
import { setTitle } from "../helpers/MetaTag";
import Searching from '../components/Searching';
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router";
import { authLogin } from "../store/authSlice";
import toastr from 'toastr';
import { postData } from "../services/api";

import { useTranslation } from "react-i18next";
import Image from '../components/elements/Image';
import { MAIN_LOGO } from '../constant/Constant';
import { Link } from 'react-router-dom';


const LoginAs = () => {
    setTitle("Succession Planning Software for your Business with Succession Now | Login as")
    const role =  localStorage.getItem("role");
    const loginAs = localStorage.getItem("loginAs")
    const [loading, setLoading] = useState(true);
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    //const [ displayMessage,setDisplayMessage] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const { t } = useTranslation();

    useEffect(() => {
        const verifyLogin = async () => {
            try {
            const userData = await postData("login-as", {
                id : params.get("user"),
            });
            if (userData.status && userData.status === 200) {
                setLoading(false);
                dispatch(authLogin(userData.data));
                localStorage.setItem("accessToken", userData?.accessToken);
                localStorage.setItem("role", userData?.data?.code);
                localStorage.setItem("loginAs", userData?.data?.login_as);
                toastr.success(userData.message);
                if(role === 'master-admin' || role === 'basic-administrator' || role === 'sales-admin' || role === 'sales-staff' || role === 'content-manager'){
                 return navigate('/dashboard-statistics')
                }else if(role === 'customer-user'){
                 return navigate('/profiles')          
                }else if(role === 'customer-subadmin'){
                    return navigate('/dashboard')          
                }else{
                 return navigate('/dashboard')          
                }
            } else {
                setLoading(false);
                //setDisplayMessage(userData.message)
            }
            } catch (error) {
                setLoading(false);
                //setDisplayMessage(error.message)
            }
        };
        if(params.get("user")){
            verifyLogin();
        }

        const backOn = async () => {
            try {
                const userData = await postData("login-as", {
                  id : loginAs
                });
                if (userData.status && userData.status === 200) {
                  setLoading(false);
                  dispatch(authLogin(userData.data));
                  localStorage.setItem("accessToken", userData?.accessToken);
                  localStorage.setItem("role", userData?.data?.code);
                  localStorage.removeItem("loginAs");
                  toastr.success(userData.message);
                  if(userData?.data?.code === 'master-admin' || userData?.data?.code === 'basic-administrator' || userData?.data?.code === 'sales-admin' || userData?.data?.code === 'sales-staff' || userData?.data?.code === 'content-manager'){
                    return navigate('/dashboard-statistics')
                   }else if(userData?.data?.code === 'customer-user'){
                    return navigate('/profiles')          
                   }else if(userData?.data?.code === 'customer-subadmin'){
                    return navigate('/profiles')          
                   }else{
                    return navigate('/dashboard')          
                   }
                } else {
                  toastr.error(userData.message);
                  setLoading(false);
                }
            } catch (error) {
                toastr.error(error.message);
                setLoading(false);
            }
        }
        if(params.get("back")){
            backOn()
        }
    }, [dispatch,loginAs,navigate,params,role]);   

    return (
        <div className="w-full min-h-screen flex justify-center items-center bg-slate-100 py-10">
            <div className="w-full max-w-sm">
                <Link to={"/"}>
                          <div className="h-14 w-full flex justify-center object-contain mb-5">
                            <Image
                              src={MAIN_LOGO}
                              alt={""}
                              width={"100%"}
                              height={"100%"}
                              classes={"object-contain object-center"}
                            />
                          </div>
                        </Link>
              <div className="w-full bg-white rounded shadow-md py-8 px-6">
                    <div className="divide-y divide-slate-200 space-y-4">
                    { loading?<Searching label={t('loading')}/>:'' }  
                    </div>
              </div>
            </div>
        </div>
    );
};

export default LoginAs;